import { ROUTES } from 'src/constants/routes.const';
import { stringifyUrl } from 'src/utils/stringifyUrl';

export type GrammarSessionUrlOptions = {
  source?: string;
  back?: string;
  pathwayNodeId?: number;
};

export const getGrammarSessionUrl = (
  languagePairId: number,
  options: GrammarSessionUrlOptions = {},
): string => {
  const params: Record<string, string | number> = { language_pair_id: languagePairId };
  if (options.source) {
    params.source = options.source;
  }
  if (options.back) {
    params.back = options.back;
  }
  if (options.pathwayNodeId !== undefined) {
    params.pathway_node_id = options.pathwayNodeId;
  }
  return stringifyUrl(ROUTES.aprender.grammar, params);
};
